import { Divider } from '../layout/divider.js'
import styles from './dnd-divider.module.css'

export const DndDivider = () => <Divider className={styles.divider} />

export default DndDivider
